import { HotelConfig } from "stores/wizard/config";
import { hotelConfigHTG } from "./hotelConfigHTG";

export const hotelConfigDefaultDates: HotelConfig = {
  ...hotelConfigHTG,
  date: {
    ...hotelConfigHTG.date,
    defaultOffsetDates: {
      start: 30,
      end: 31,
    },
  },
};
